import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoLarge = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 44,
	viewBox: "0 0 200 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	role: "img",
	"aria-label": "Nevai Meet",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 6,
			width: 32,
			height: 32,
			rx: 9,
			fill: "#0DBD8B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 15 L14 29 L27 22 Z",
			fill: "#ffffff"
		}),
		/* @__PURE__ */ _jsxs("text", {
			x: 44,
			y: 29,
			fontFamily: "Segoe UI, Helvetica, Arial, sans-serif",
			fontSize: 22,
			fontWeight: 700,
			children: [/* @__PURE__ */ _jsx("tspan", {
				fill: "#0DBD8B",
				children: "Nevai"
			}), /* @__PURE__ */ _jsx("tspan", {
				fill: "#0F1419",
				children: " Meet"
			})]
		})
	]
});
const ForwardRef = forwardRef(SvgLogoLarge);
export default ForwardRef;
